export default __webpack_public_path__ + "static/media/UY_logo.dcd00d8c.png";